
export default function loadAuthFromLocalStorage(dispatch) {
    let token = localStorage.getItem('token');
    let user = JSON.parse(localStorage.getItem('user'));
    if (token && user) {
        dispatch({
            token,
            user,
            type: 'LOAD_AUTH_FROM_LOCAL_STORAGE'
        });
    } else {
        let lastUser = JSON.parse(localStorage.getItem('lastUser'));
        if(lastUser) {
            dispatch({
                lastUser,
                type: 'LOAD_LAST_USER_FROM_LOCAL_STORAGE'
            });
        }
    }
}


// WEBPACK FOOTER //
// ./app/auth/LoadAuthFromLocalStorage.js